//retrieve the REACT_APP_API_URI from the .env file
var url =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? process.env.REACT_APP_API_URI_DEV
    : process.env.REACT_APP_API_URI_PROD;

var config = { url: url, environment: process.env.REACT_APP_ENVIRONMENT };
console.log(config.environment);
export default config;
